'use client'
import { Input } from '@cleanlab/design-system/components'
import { cn } from '@cleanlab/design-system/utils'
import { type E164Number } from 'libphonenumber-js'
import PhoneInput from 'react-phone-number-input'

import styles from './PhoneNumberInput.module.css'

export const PhoneNumberInput = ({
  className,
  value,
  onChange,
}: {
  className?: string
  value?: string
  onChange: (value: E164Number | undefined) => void
}) => {
  return (
    <PhoneInput
      className={cn(styles.phoneInput, 'flex w-full items-stretch', className)}
      international
      defaultCountry="US"
      countrySelectProps={{ unicodeFlags: true, tabIndex: 0 }}
      placeholder="+1 (123) 345-6789"
      inputComponent={Input}
      numberInputProps={{
        className: 'rounded-none rounded-r-2 ml-[-1px] z-10',
        autoComplete: 'tel',
      }}
      value={value}
      onChange={onChange}
    />
  )
}
